export function useInstance() {
  const isEnergyPOSInstance = () => {
    const instanceCode = process.env.VUE_APP_INSTANCE_CODE;
    return /ENERGY_POS/.test(instanceCode);
  }

  const isEnergyPosSVInstance = () => {
    const instanceCode = process.env.VUE_APP_INSTANCE_CODE;
    return instanceCode === "ENERGY_POS_SV";
  }

  const isMexicoInstance = () => {
    return process.env.VUE_APP_INSTANCE_CODE === 'MX'
  }

  const isArgentinaInstance = () => {
    return process.env.VUE_APP_INSTANCE_CODE === 'AR'
  }

  const isSpainInstance = () => {
    return process.env.VUE_APP_INSTANCE_CODE === 'ES'
  }

  const getInstanceJiraCode = () => {
    const instanceCode = process.env.VUE_APP_INSTANCE_CODE;
    return instanceCode.includes("ENERGY_POS") ? "EGY" : "BIS";
  }

  return {
    isEnergyPOSInstance,
    isEnergyPosSVInstance,
    isMexicoInstance,
    isArgentinaInstance,
    isSpainInstance,
    getInstanceJiraCode
  }
}